import { render, staticRenderFns } from "./AppBackup.vue?vue&type=template&id=0bffdf20"
import script from "./AppBackup.vue?vue&type=script&lang=js"
export * from "./AppBackup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports